import type { User } from '@shared/api';

const USER = 'user';

export class LocalStorageUtils {
  static getUser = (): User | null => {
    const user = localStorage.getItem(USER);
    return user ? JSON.parse(user) : null;
  };
  static setUser = (user: User) => localStorage.setItem(USER, JSON.stringify(user));
  static removeUser = () => localStorage.removeItem(USER);
}
